"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoteSourceModal = void 0;
/* Package Imports */
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
/* Imported CSS */
require("./RemoteSourceModal.scss");
var HaloSpinnerWithText_1 = require("@app/components/HaloSpinnerWithText");
var Toast_1 = require("@app/components/controls/Toast");
var YellowButton_1 = require("@app/components/controls/YellowButton");
var Modal_1 = require("@app/components/layout/Modal");
var ModalContent_1 = require("@app/components/layout/ModalContent");
var SelectableFileList_1 = require("@app/features/transfers/components/upload/SelectableFileList");
var actions_1 = require("@app/features/ui/state/actions");
var constants_1 = require("@app/shared/constants");
var initialState = {
    selectedFiles: []
};
/**
 * Remote Source Modal component, displays the file contents for an available remote server inside a pop-up modal window
 */
var RemoteSourceModal = /** @class */ (function (_super) {
    __extends(RemoteSourceModal, _super);
    function RemoteSourceModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = initialState;
        /* Component Lifecycle Methods - end */
        /* Component Methods - begin */
        _this.handleFileSelect = function (file, selected) {
            if (selected) {
                if (_this.state.selectedFiles.findIndex(function (f) { return (f.filename === file.filename &&
                    f.path === file.path &&
                    f.type === file.type); }) === -1) {
                    _this.setState({ selectedFiles: __spreadArray(__spreadArray([], _this.state.selectedFiles), [file]) });
                }
            }
            else {
                var newSelectedFiles = _this.state.selectedFiles.filter(function (f) { return (f.filename !== file.filename &&
                    f.path !== file.path); });
                _this.setState({ selectedFiles: newSelectedFiles });
            }
        };
        _this.handleLoadMore = function () {
            _this.props.onLoadMore(_this.props.remoteFilesList.length);
        };
        _this.handleSelect = function () {
            _this.props.onSelect(_this.state.selectedFiles);
        };
        return _this;
    }
    /* Component Lifecycle Methods - begin */
    RemoteSourceModal.prototype.componentWillUnmount = function () {
        this.setState(initialState);
    };
    /* Component Methods - end */
    RemoteSourceModal.prototype.render = function () {
        // Component properties
        var props = this.props;
        /* Remote Source modal constants */
        var parentDirectory = props.currentPath.substring(0, props.currentPath.lastIndexOf('/'));
        return (react_1.default.createElement(Modal_1.Modal, __assign({}, props),
            react_1.default.createElement(ModalContent_1.ModalContent, { title: "Remote Source: " + props.sourceTitle, className: "remote-source-modal", onCloseClick: props.onClose },
                react_1.default.createElement("p", { className: "current-path" },
                    props.sourceTitle,
                    props.currentPath),
                this.props.isLoadingRemoteFiles ?
                    react_1.default.createElement(HaloSpinnerWithText_1.HaloSpinnerWithText, { value: '' })
                    :
                        react_1.default.createElement(SelectableFileList_1.SelectableFileList, { className: ((props.remoteFilesList.length > 0) && ((props.remoteFilesList.length % constants_1.REMOTE_SOURCE_FILES_REQUEST_SIZE) === 0)) ? 'extra-padding' : '', currentPath: props.currentPath, files: __spreadArray([
                                {
                                    filename: '.. Parent Directory',
                                    size: 0,
                                    type: 'directory',
                                    path: (parentDirectory) ? parentDirectory : '/'
                                }
                            ], props.remoteFilesList.map(function (file) {
                                return {
                                    filename: file.path.substring(file.path.lastIndexOf('/') + 1),
                                    size: file.size,
                                    type: file.type,
                                    path: file.path
                                };
                            })), onOpen: props.onOpen, onSelect: this.handleFileSelect, selectedFiles: this.state.selectedFiles }),
                react_1.default.createElement("div", { className: "select-button" },
                    react_1.default.createElement(YellowButton_1.YellowButton, { type: "button", className: "button-yellow", onClick: this.handleSelect }, "Add"),
                    props.remoteFilesList.length >= constants_1.REMOTE_SOURCE_FILES_REQUEST_SIZE &&
                        react_1.default.createElement(Toast_1.Toast, { message: props.toasts[actions_1.ToastType.REMOTE_SOURCE_LOAD_MORE], className: 'is-pulled-right', height: 26, position: 'top', width: 100 },
                            react_1.default.createElement(YellowButton_1.YellowButton, { type: "button", className: "button-yellow is-pulled-right", disabled: !((props.remoteFilesList.length > 0) && ((props.remoteFilesList.length % constants_1.REMOTE_SOURCE_FILES_REQUEST_SIZE) === 0)), onClick: this.handleLoadMore }, "Load More"))))));
    };
    return RemoteSourceModal;
}(react_1.Component));
exports.RemoteSourceModal = RemoteSourceModal;
var mapStateToProps = function (state) {
    return {
        toasts: state.ui.toasts
    };
};
exports.default = react_redux_1.connect(mapStateToProps)(RemoteSourceModal);
